import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import loadScripts from '../../../dassets/js/custom';
class AuthorizedSignatory3 extends Component {
    componentDidMount() {
      loadScripts();
    }
    constructor(props) {
        super(props);

        this.saveAndContinue = this.saveAndContinue.bind(this);
        this.onChangeSignature = this.onChangeSignature.bind(this);
        this.data = {
            signature: null,
        }
    }

    saveAndContinue(e) {
        e.preventDefault()

        // Get values via this.refs
        let data = {
            title: this.refs.__as_title.value,
            gender: this.refs.__as_gender.value,
            surname: this.refs.__as_surname.value,
            first_name: this.refs.__as_first_name.value,
            other_name: this.refs.__as_other_name.value,
            email: this.refs.__as_email.value,
            dob: this.refs.__as_dob.value,
            res_add: this.refs.__as_res_add.value,
            id_means: this.refs.__as_id_means.value,
            phone: this.refs.__as_phone.value,
            designation: this.refs.__as_designation.value,
            signature: this.data.signature,
            signature_path: this.data.signature ? `cform_signature_${this.refs.__as_surname.value}_${this.refs.__as_first_name.value}_${new Date().getTime()}.png` : null
        }

        this.props.saveValues(data, 'authorized_signatory', 2)
        this.props.nextStep()
    }

    onChangeSignature(e) {
        const fileTypes = ['image/png', 'image/gif', 'image/jpeg'];

        let file = e.target.files[0];
        if (fileTypes.every(extension => file.type !== extension)) {
            toast.error(`The file ${file.type} extension is not supported`);
            return
        }
        this.data.signature = file;
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="text-danger mb-4">Authorized Signatory (Authorized Person 3)</h4>
                                <form onSubmit={this.saveAndContinue}>
                                    <div className="row">
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Title</label>
                                            <select ref="__as_title" className="form-control" defaultValue={this.props.fieldValues.title}>
                                                <option value="" hidden>Select...</option>
                                                <option value="Mr">Mr</option>
                                                <option value="Miss">Miss</option>
                                                <option value="Mrs">Mrs</option>
                                                <option value="Chief">Chief</option>
                                                <option value="Dr.">Dr.</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Gender</label>
                                            <select ref="__as_gender" className="form-control" defaultValue={this.props.fieldValues.gender}>
                                                <option value="" hidden>Select...</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Email Address</label>
                                            <Form.Control type="email" className="form-control" ref="__as_email" placeholder="Email Address" defaultValue={this.props.fieldValues.email} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Surname</label>
                                            <Form.Control type="text" className="form-control" ref="__as_surname" placeholder="Surname" defaultValue={this.props.fieldValues.surname} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>First Name</label>
                                            <Form.Control type="text" className="form-control" ref="__as_first_name" placeholder="First Name" defaultValue={this.props.fieldValues.first_name} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Other Name</label>
                                            <Form.Control type="text" className="form-control" ref="__as_other_name" placeholder="Other Name" defaultValue={this.props.fieldValues.other_name} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Date of Birth</label>
                                            <Form.Control type="date" className="form-control" ref="__as_dob" placeholder="Date of Birth" defaultValue={this.props.fieldValues.dob} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Residential Address</label>
                                            <Form.Control type="text" className="form-control" ref="__as_res_add" placeholder="Residential Address" defaultValue={this.props.fieldValues.res_add} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Means of Identification</label>
                                            <select ref="__as_id_means" className="form-control" defaultValue={this.props.fieldValues.id_means}>
                                                <option value="" hidden>Select...</option>
                                                <option value="International Passport">International Passport</option>
                                                <option value="Driver's Licence">Driver's Licence</option>
                                                <option value="National ID Card">National ID Card</option>
                                                <option value="Permanent Voters Card">Permanent Voters Card</option>
                                                <option value="Utility Bill">Utility Bill</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Telephone Number</label>
                                            <Form.Control type="text" className="form-control uint" ref="__as_phone" placeholder="Telephone Number" defaultValue={this.props.fieldValues.phone} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Designation</label>
                                            <Form.Control type="text" className="form-control" ref="__as_designation" placeholder="Designation" defaultValue={this.props.fieldValues.designation} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label htmlFor="attachments"><i className="fa fa-paperclip"></i> Signature</label>
                                            <Form.Control onChange={this.onChangeSignature} type="file" className="form-control" ref="__as_attachments" accept=".jpeg,.jpg,.gif,.png" />
                                        </Form.Group>
                                    </div>
                                    <button onClick={this.props.previousStep} type="button" className="btn btn-primary mr-2">Previous</button>
                                    <button type="submit" className="btn btn-primary mr-2">Save and Continue</button>
                                </form>
                            </div >
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AuthorizedSignatory3;